var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameConsoleHandheld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 0H64C28.8 0 0 28.8 0 64l.0001 352c0 52.8 43.2 96 96 96h192c53.02 0 96-42.98 96-96L384 63.1C384 28.8 355.2 0 320 0zM336 416c0 26.51-21.49 48-48 48H96c-26.51 0-48-21.49-48-48V64c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16V416zM128 240h127.1C273.6 240 288 225.6 288 208V112C288 103.2 280.8 96 272 96h-160C103.2 96 95.1 103.2 96 112l.0001 96C96 225.7 110.3 240 128 240zM160 320H144L144 304C144 295.2 136.8 288 128 288S112 295.2 112 304V320H96C87.2 320 80 327.2 80 336c0 8.799 7.199 16 16 16H112v16C112 376.8 119.2 384 128 384s16-7.201 16-16L144 352H160c8.801 0 16-7.201 16-16C176 327.2 168.8 320 160 320zM232 336c-13.25 0-24 10.75-24 24s10.75 24 24 24s24-10.75 24-24S245.3 336 232 336zM280 288C266.8 288 256 298.8 256 312s10.75 24 24 24s24-10.75 24-24S293.3 288 280 288z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameConsoleHandheld);
export default __webpack_public_path__ + "static/media/game-console-handheld.f0b7e1b99ae0c3c728d36abbb759753a.svg";
export { ForwardRef as ReactComponent };